import Axios from "axios";
import {
    SET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST,
    UNSET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST,
    SET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION,
    UNSET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION
} from "@/store/mutation-types";
import { saveUpdateFixedPercentageCommission, getSalesFixedPercentageCommissionList, getSalesFixedPercentageCommissionById } from "@/store/api";

const state = {
    getSalesFixedPercentageCommissionList: [],
    editingSalesFixedPercentageCommission: null,
};

const getters = {
    getSalesFixedPercentageCommissionList(state) {
        return state.getSalesFixedPercentageCommissionList;
    },
    getEditingSalesFixedPercentageCommission(state) {
        return state.editingSalesFixedPercentageCommission;
    }
};

const mutations = {
    [SET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST](state, data) {
        state.getSalesFixedPercentageCommissionList = data;
    },
    [UNSET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST](state) {
        state.getSalesFixedPercentageCommissionList = [];
    },
    [SET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION](state, data) {
        state.editingSalesFixedPercentageCommission = data;
    },
    [UNSET_EDITING_SALES_FIXED_PERCENTAGE_COMMISSION](state) {
        state.editingSalesFixedPercentageCommission = [];
    }
};

const actions = {
    saveUpdateFixedPercentageCommission({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateFixedPercentageCommission, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesFixedPercentageCommissionList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesFixedPercentageCommissionList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_FIXED_PERCENTAGE_COMMISSION_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleFixedPercentageCommissionById({ commit }, data) {
        const getSalePercentageCommission = `${getSalesFixedPercentageCommissionById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalePercentageCommission)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
